<template>
  <div class="content">
    <div class="middled">
      <div v-show="loading" style="text-align:center;">Loading...</div>

      <div v-show="!loading" style="border-bottom:2px solid #333;padding:6px 0 0 0;margin:0 6px;">
        <div style="padding:6px 0;">
          <h2 style="margin-top: 0;">{{ account.account_name }} Account</h2>
        </div>
      </div>

      <div class="row">
        <div class="column" v-show="!loading">
          <div class="account_contact_info">
            <input type="text" v-model="account.account_name" placeholder="Account Name" />
            <input type="text" v-model="account.account_contact_name" placeholder="Account Contact" />
            <input type="email" v-model="account.account_email" placeholder="Email" />
            <input type="tel" v-model="account.account_phone" placeholder="Phone Number" />
            <input type="tel" v-model="account.account_fax" placeholder="Fax Number (optional)" />
            <input type="text" v-model="account.account_tid" placeholder="Tax ID (optional)" />
            <input type="text" v-model="account.account_license" placeholder="License (optional)" />
            <h2>Address</h2>
            <input type="text" v-model="account.account_address" placeholder="Address" />
            <input type="text" v-model="account.account_city" placeholder="City" />
            <input type="text" v-model="account.account_state" placeholder="State" />
            <input type="text" v-model="account.account_zip" placeholder="Zip" />
            <input type="text" v-model="account.account_country" placeholder="Country" />
            <div style="text-align: right;">
              <input type="checkbox" v-model="account.deleted"> Delete account?
            </div>
          </div>
          <div class="row" style="margin:10px 0;">
            <button class="btn-add" @click="updateAccount" style="margin-right:10px;">Save Changes</button>
            <router-link :to="this.$route.query.r">
              <button class="btn">Cancel</button>
            </router-link>
          </div>
          <div v-if="error" class="alert alert-danger">{{error}}</div>
          <div v-if="msg" class="message">{{error}}</div>
        </div>
        <div class="column">
            <div v-if="account.logo_url" style="text-align:center;vertical-align:middle;">
                <img v-on:click="editLogo = true" style="width:100px;cursor:pointer;" :src="'https://corl8-files.s3.amazonaws.com/' + account.logo_url" alt="logo">
            </div>
            <div style="text-align:center;margin-top:20px;">
              <a href="#" @click.prevent="editLogo = true"> Upload Logo </a> |
              <router-link :to="this.$route.query.r"> Done </router-link>
            </div>
        </div>
      </div>
    </div>

    <!-- use the modal component, pass in the prop -->
    <UploadLogo v-if="editLogo" @close="editLogo = false" :account="account"></UploadLogo>

  </div>
</template>

<script>
import { isLoggedIn } from "../utils/auth";
import { accountService } from "../_services/account.service"
import UploadLogo from "@/components/includes/UploadLogo";
import { userService } from "../_services/user.service";

export default {
  title: 'Account | Foclarity',
  name: "Account",
  mounted: function() {
    if (isLoggedIn()) {
      // this.$router.push("dashboards");
    }
  },
  methods: {
    isLoggedIn() {
      return isLoggedIn();
    },
    updateAccount: function () {
        accountService.updateAccount(
          this.account.account_name, 
          this.account.account_contact_name,
          this.account.account_address,
          this.account.account_city,
          this.account.account_state,
          this.account.account_zip,
          this.account.account_country,
          this.account.account_phone,
          this.account.account_fax,
          this.account.account_email,
          this.account.account_tid,
          this.account.account_license,
          this.account.deleted
        ).then(
            data => {
                if (data.account) {
                  if (this.$route.query.r) {
                    this.$router.push(this.$route.query.r)
                  } else {
                    this.$router.push("/accounts")
                  }
                } else {
                    this.msg = data
                }
            },
            error => {
                this.error = error
            }
        )
    },
    getAccount: function () {
      let aid = this.$route.params.account_id
      accountService.readAccount(aid).then(
          data => {
            this.account = data
            this.loading = false
        },
        error => {
          this.error = error
          this.loading = false
        }
        )
    },
  },
  components: {
    UploadLogo
  },
  data () {
      return {
        account: '',
        user: '',
        aid: '',
        submitted: false,
        editLogo: false,
        loading: true,
        returnUrl: '',
        error: '',
        msg: ''
      }
  },
  created () {
    this.account = accountService.getActiveAccount();
    userService.getMe().then(data => {
      this.user = data
      if (this.user.user_id === this.account.user_id) {
        this.getAccount()
      } else {
        this.$router.push("/dashboards")
      }
    })
  }
};
</script>

<style lang="scss" scoped>
input {
    margin:4px 0 ;
}

.welcomeback {
  padding: 40px;
  text-align: center;
  border: 1px solid #ccc;
}

.heroblue {
  background: linear-gradient(110deg, #00b2ee 60%, #007cee 60%);
  height: 320px;
  margin: -20px -20px 20px -20px;
  border-radius: 4px 4px 0 0;
  @media only screen and (max-width: 440px) {
    border-radius: 0px 0px 0 0;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  & h1 {
    text-align: center;
    color: #fff;
    font-size: 45px;
    max-width: 600px;
    @media (max-width: 415px) {
      font-size: 36px;
      padding: 20px;
    }
  }
  & a {
    text-decoration: none;
    color: #fff;
    & .signupbox {
      text-align: center;
      padding: 8px;
      font-size: 24px;
      font-weight: bold;
      background: #ff7f24;
      width: 300px;
      border-radius: 10px;
      border: 1px solid #fff;
      margin: auto;
    }
  }
}

</style>

